// Code review - Completed
// Documentation - Completed
import { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";

const Itemspopup = ({ data, data2 }) => {
  

  

  return (
    <div class="w-full ">
      <div className={mainTable.addShadowScreen}>
        <div className={mainTable.mainContentScreen}>
          <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit">
            <div className={mainTable.grid3}>

                 <AutoDropDown
                title="Items Type"
                classStar={"text-red-500"}
                placeholder="Select"
                options={[]}
                Class="p-0"
                name="Commodity"
                selectedOption={data2[2]}
                disabled={true}
              />
              <AutoDropDown
                title={`Item Categories`}
                classStar={"text-red-500"}
                placeholder="Select"
                options={[]}
                Class="p-0"
                name="Commodity"
                selectedOption={data2[0]}
                disabled={true}
              />
              <InputText
                inputType="text"
                title="Item Name"
                classStar={"text-red-500"}
                name="productName"
                content={data.ItemName}
                disabled={true}
              />
            
              <AutoDropDown
                title="Unit Of Measure"
                placeholder="Select"
                options={[]}
                classStar={"text-red-500"}
                Class="p-0"
                name="Commodity"
                selectedOption={data2[1]}
                disabled={true}
              />
       
              <InputText
                inputType="text"
                title="Re-Order Level"
                placeholder="100"
                classStar={"text-red-500"}
                name="reOrderLevel"
                content={data.ItemReOrderLevel}
                disabled={true}
              />
              <InputText
                inputType="text"
                title="Description"
                placeholder="Description"
                name="description"
                content={data && data.Description ? data.Description : ""}
                disabled={true}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Itemspopup;
